module.exports = __webpack_public_path__ + "static/media/Drawphone.cb962478.png";